export default __webpack_public_path__ + "static/media/table.fac2760f.png";